// Import Action Types
import {
  FETCH_PENDING_CONTENTS_REQUEST,
  FETCH_PENDING_CONTENTS_SUCCESS,
  FETCH_PENDING_CONTENTS_FAILURE,
  APPROVE_CONTENT_REQUEST,
  APPROVE_CONTENT_SUCCESS,
  APPROVE_CONTENT_FAILURE,
  REJECT_CONTENT_REQUEST,
  REJECT_CONTENT_SUCCESS,
  REJECT_CONTENT_FAILURE,
  SET_CONTENT_APPROVAL_FILTERS,
  CLEAR_CONTENT_APPROVAL_ERROR,
  RESET_CONTENT_APPROVAL_STATE
} from './_actionTypes';

// Action Creators - Fetch Pending Contents
export const fetchPendingContentsRequest = (filters = {}) => ({
  type: FETCH_PENDING_CONTENTS_REQUEST,
  payload: filters
});

export const fetchPendingContentsSuccess = (data) => ({
  type: FETCH_PENDING_CONTENTS_SUCCESS,
  payload: data
});

export const fetchPendingContentsFailure = (error) => ({
  type: FETCH_PENDING_CONTENTS_FAILURE,
  payload: error
});

// Action Creators - Approve Content
export const approveContentRequest = (contentId) => ({
  type: APPROVE_CONTENT_REQUEST,
  payload: contentId
});

export const approveContentSuccess = (contentId) => ({
  type: APPROVE_CONTENT_SUCCESS,
  payload: contentId
});

export const approveContentFailure = (error) => ({
  type: APPROVE_CONTENT_FAILURE,
  payload: error
});

// Action Creators - Reject Content
export const rejectContentRequest = (contentId, reason) => ({
  type: REJECT_CONTENT_REQUEST,
  payload: { contentId, reason }
});

export const rejectContentSuccess = (contentId) => ({
  type: REJECT_CONTENT_SUCCESS,
  payload: contentId
});

export const rejectContentFailure = (error) => ({
  type: REJECT_CONTENT_FAILURE,
  payload: error
});

// Action Creators - Filters and UI
export const setFilters = (filters) => ({
  type: SET_CONTENT_APPROVAL_FILTERS,
  payload: filters
});

export const clearError = () => ({
  type: CLEAR_CONTENT_APPROVAL_ERROR
});

export const resetState = () => ({
  type: RESET_CONTENT_APPROVAL_STATE
});